import AnimatedSection from '../common/AnimatedSection';

/* ─── Team Data ────────────────────────────────────────────── */
// const teamData = [
//   { 
//     name: 'Sandeep Sharma', 
//     role: 'CEO', 
//     img: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80&w=400' 
//   },
//   { 
//     name: 'Anjali Rai', 
//     role: 'Managing Director', 
//     img: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=400' 
//   },
//   { 
//     name: 'Bikash Thapa', 
//     role: 'Sr. Consultant', 
//     img: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=400' 
//   },
//   { 
//     name: 'Sita Verma', 
//     role: 'Ops Head', 
//     img: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80&w=400' 
//   },
// ];

/* ─── Main Component ───────────────────────────────────────── */
const TeamOnly = ({teamData}) => (
  <section id="team" className="relative bg-white py-24 overflow-hidden">
    {/* Subtle Background Accent */}
    <div className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full bg-indigo-50/50 blur-3xl" />

    <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
      
      {/* Section Header */}
      <AnimatedSection>
        <div className="text-center mb-20">
          <span className="text-primary text-[11px] font-black tracking-[0.2em] uppercase mb-3 block">
            Expert Leadership
          </span>
          <h2 className="text-4xl md:text-6xl font-extrabold text-dark tracking-tighter leading-tight">
            The Minds Behind <span className="text-primary italic">BTI.</span>
          </h2>
          <div className="w-12 h-1.5 bg-primary mx-auto mt-8 rounded-full" />
        </div>
      </AnimatedSection>

      {/* Team Grid - Static Layout */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12">
        {teamData?.data?.map((member, i) => (
          <AnimatedSection key={i} delay={0.1 * i}>
            <div className="text-center">
              {/* Image Container: Rounded with Border, No Grayscale/Hover */}
              <div className="aspect-[4/5] rounded-[2.5rem] overflow-hidden bg-slate-50 mb-6 border border-slate-100 shadow-sm">
                <img 
                  src={member?.image} 
                  alt={member?.name} 
                  className="w-full h-full object-contain" 
                />
              </div>
              
              {/* Typography: Clean and Static */}
              <h4 className="font-bold text-dark text-lg md:text-xl">
                {member?.name}
              </h4>
              <p className="text-[10px] md:text-xs text-dark/40 font-bold uppercase tracking-[0.15em] mt-2">
                {member?.designation}
              </p>
            </div>
          </AnimatedSection>
        ))}
      </div>

    </div>
  </section>
);

export default TeamOnly;